import React from 'react'
import styled from 'styled-components'

import AU from 'svg-country-flags/svg/au.svg'
import CA from 'svg-country-flags/svg/ca.svg'
import GB from 'svg-country-flags/svg/gb.svg'
import US from 'svg-country-flags/svg/us.svg'
import EU from 'svg-country-flags/svg/eu.svg'
import SE from 'svg-country-flags/svg/se.svg'
import JP from 'svg-country-flags/svg/jp.svg'
import DE from 'svg-country-flags/svg/de.svg'
import NZ from 'svg-country-flags/svg/nz.svg'
import NO from 'svg-country-flags/svg/no.svg'
import LT from 'svg-country-flags/svg/lt.svg'
import NL from 'svg-country-flags/svg/nl.svg'
import CZ from 'svg-country-flags/svg/cz.svg'
import IT from 'svg-country-flags/svg/it.svg'
import BE from 'svg-country-flags/svg/be.svg'
import FR from 'svg-country-flags/svg/fr.svg'
import CH from 'svg-country-flags/svg/ch.svg'
import UG from 'svg-country-flags/svg/ug.svg'

const mapping = {
  au: AU,
  ca: CA,
  gb: GB,
  us: US,
  eu: EU,
  se: SE,
  jp: JP,
  de: DE,
  nz: NZ,
  no: NO,
  lt: LT,
  nl: NL,
  cz: CZ,
  it: IT,
  be: BE,
  fr: FR,
  ch: CH,
  ug: UG,
}

export default styled(({ country, className }) => {
  const Flag = mapping[country]
  return Flag ? <Flag className={className} /> : null
})`
  border: 1px solid black;
`
